import { useQuery } from '@tanstack/react-query';
import adminInventoryService from '../../services/adminInventoryService';
import useAdminInventoryStore from '../../store/useAdminInventoryStore';

export const useInventoryTable = () => {
  const filters = useAdminInventoryStore((state) => state.filters);
  const page = useAdminInventoryStore((state) => state.page);

  const params = {
    page,
    search: filters.search,
    supplier: filters.supplier?.id,
    warehouse: filters.warehouse?.id,
    is_active: filters.is_active,
    inventory_is_active: filters.inventory_is_active,
    date_from: filters.date_from,
    date_to: filters.date_to,
    ordering: filters.ordering,
  };

  return useQuery({
    queryKey: ['admin-inventory-table', params],
    queryFn: () => adminInventoryService.getInventoryTable(params),
    keepPreviousData: true,
  });
};
